module.exports = __webpack_public_path__ + "assets/3a9a8600cbca3fc9d776a91514dbfb59.mp4";